import { IDP_GROUP_COLUMN_ID } from "../constants";
import IdpGroupMappingTableNameCell from "./NameCell";
import IdpGroupMappingTableUsersCell from "./UsersCell";
import IdpGroupMappingTableLastLoginCell from "./LastLoginCell";
import IdpGroupMappingTableLoginMethodCell from "./LoginMethodCell";
import IdpGroupMappingTableStatusCell from "./StatusCell";
import IdpGroupMappingTableRowActionsCell from "./RowActionsCell";
import IdpGroupMappingTableDescriptionCell from "./DescriptionCell";

export const IDP_GROUP_TABLE_CELLS = {
  [IDP_GROUP_COLUMN_ID.GROUP_ID]: IdpGroupMappingTableNameCell,
  [IDP_GROUP_COLUMN_ID.DESCRIPTION]: IdpGroupMappingTableDescriptionCell,
  [IDP_GROUP_COLUMN_ID.USERS]: IdpGroupMappingTableUsersCell,
  [IDP_GROUP_COLUMN_ID.LAST_LOGIN]: IdpGroupMappingTableLastLoginCell,
  [IDP_GROUP_COLUMN_ID.LOGIN_METHOD]: IdpGroupMappingTableLoginMethodCell,
  [IDP_GROUP_COLUMN_ID.STATUS]: IdpGroupMappingTableStatusCell,
  [IDP_GROUP_COLUMN_ID.DROPDOWN]: IdpGroupMappingTableRowActionsCell,
};
